// Tandem Tool — base for Tool-system implementations (file ops, etc.) registered on TandemToolSystem.
// Parallels WorkspaceTool: extends BaseTool, provides tandemManager + tandemAPI path helpers.

import { BaseTool } from "../../../base/BaseTool.js";

export class TandemTool extends BaseTool {
  get tandemManager() {
    return this.toolSystem?.tandemManager || null;
  }

  /**
   * Revolt Desktop IPC for Tandem native file operations.
   * @returns {Record<string, Function>|null}
   */
  getTandemLocalAppApi() {
    if (typeof window === "undefined") return null;
    return window.tandemAPI || null;
  }

  /**
   * Absolute project root from section TandemManager (user-picked folder).
   * @returns {string|null}
   */
  getTandemWorkingDirectoryRoot() {
    const raw = this.tandemManager?.workingDirectoryPath;
    if (!raw || typeof raw !== "string") return null;
    const t = raw.trim();
    return t.length ? t : null;
  }

  /**
   * Normalize and validate a project-relative path (no `..`, forward slashes).
   * @param {string} path - Path to normalize
   * @returns {string|null} Path with leading `/` or null if invalid
   */
  normalizeAndValidatePath(path) {
    if (!path || typeof path !== "string") {
      return null;
    }

    let normalized = path.replace(/^\/+/, "");

    if (normalized.includes("..")) {
      return null;
    }

    normalized = normalized.replace(/\\/g, "/");

    return `/${normalized}`;
  }
}
